/* tslint:disable */
/* eslint-disable */
export enum RegistrationStatus {
  Success = 0,
  InvalidEmail = 1,
  UserAlreadyRegistered = 2,
  UnexpectedError = 3,
  ReadOnlyModeEnabled = 4
}
